export default function Footer() {
    return (
        <div style={{ backgroundColor: '#00354C' }}>
            <footer className='container py-4 mt-5'>
                <div className='row text-light'>
                    <div className='col-lg-9 col-xs-9 text-start'>
                    </div>
                    <div className="col-lg-3 col-xs-3 text-end">
                    </div>

                </div>
            </footer>
        </div>
    )
}